<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true" >
      <CenterNavbar :crumps="[]" title="Privacy Policy" :width_class="page_info.center_width_class" ></CenterNavbar>
      <ContactPageBanner :has_nav_bar="true"  id="policy_top" bg_class="bg-0" :bg_url="bg_url"></ContactPageBanner>
      <PolicyText></PolicyText>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>


<script>
import Page from "./../../components/Page";

import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import ContactPageBanner from "./../../components/ContactPageBanner";
import PolicyText from "./../../components/PolicyText";
import Footer from "./../../components/CenterFooter";

import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";

import page_info from "./../../lib/page_info";

export default {
  name: "Policy",
  components: {
    Page,

    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,

    CenterPageColumn,
    CenterNavbar,
    ContactPageBanner,
    PolicyText,
    Footer,

    SelfPromoAdd,
    HomeSideAdsContainer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      page: "terms",
      quick_links: [
        {
          text: "Introduction",
          href: "#terms_introduction",
        },
        {
          text: "Your Content",
          href: "#terms_your_content",
        },
        {
          text: "Indemnification",
          href: "#terms_indemnification",
        },
        {
          text: "Assignment",
          href: "#terms_assignment",
        }
      ],
      bg_url: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601730151/botswana%20services/website%20assets/Botswana-Stock-Exchange-COVID-19-Africa-Watch-1030x391_popbyj.png",
      page_info:page_info
    };
  },
  mounted() {
    var options = {
      offset: 102,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#policy_top", options);
  }
};
</script>